import {
    type ComponentType,
    type InputHTMLAttributes,
    type ReactElement,
    type ReactNode,
} from "react";
import { Input } from "./Input";
import { LabelField } from "./LabelField";
import { cn } from "@/lib/utils";

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    label: string;
    labelExtra?: ReactNode;
    icon?: ComponentType<{ className?: string }>;
    description?: string;
    error?: string;
    filled?: boolean;
}

export function InputField({
    label,
    labelExtra,
    icon,
    description,
    error,
    filled = true,
    id,
    name,
    className,
    ...props
}: InputFieldProps): ReactElement {
    const fieldId = id ?? name;

    return (
        <LabelField
            label={label}
            htmlFor={fieldId}
            labelExtra={labelExtra}
            icon={icon}
            description={description}
            error={error}
        >
            <Input
                id={fieldId}
                name={name}
                className={cn(
                    "w-full h-9 pb-2 pl-0 border-0 border-b border-b-foreground/30 text-lg font-medium break-all rounded-none rounded-t shadow-none focus-visible:ring-0 focus-visible:border-b-foreground autofill:[-webkit-text-fill-color:hsl(var(--foreground))]",
                    filled ? "mt-1.5 pt-4 pb-3 px-3" : "pt-5 pb-2",
                    filled
                        ? "bg-[#efeee9] autofill:shadow-[inset_0_0_0px_1000px_#efeee9]"
                        : "bg-transparent autofill:shadow-[inset_0_0_0px_1000px_hsl(var(--card))]",
                    icon ? "pl-5" : "",
                    error ? "border-b-destructive focus-visible:border-b-destructive" : "",
                    className,
                )}
                {...props}
            />
        </LabelField>
    );
}
